<template>
  <v-content>
    <v-layout style="background-color: #FAF5F2;">
      <v-flex>
        <v-layout mb-3 mt-6>
          <v-flex style="color: #3E7662;font-weight: bold;font-size: 28px">
            <span>แบบฟอร์ม</span>
          </v-flex>
        </v-layout>

        <v-layout class="mx-12">
          <v-flex>
            <v-layout mt-3 style="background-color: #3E7662;">
              <v-flex my-8 ml-8 style="text-align: left;font-size: 28px;color: white">
                <div style="font-weight: bold">
                  คู่มือการตรวจสอบความครบถ้วนของโครงร่างการวิจัย
                </div>
              </v-flex>
              <v-flex ml-8 pt-8 pr-8 style="text-align: right;font-weight: bold;font-size: 13px;color: white">
                <span>RO 02_2563</span>
              </v-flex>
            </v-layout>

            <!-- blog 1 -->
            <v-card flat class="pa-12">
              <!-- row 1 -->
              <v-layout>
                <v-flex shrink mr-4 pt-2 style="text-align: right;font-weight: bold;">
                  <span>ชื่อโครงการ</span>
                </v-flex>
                <v-flex xs10>
                  <textfield-form :model="form.researchName" @update-data="updateData('researchName', $event)"
                    readonly></textfield-form>
                </v-flex>
              </v-layout>

              <!--radio group-->

              <v-layout style="text-align: left">
                <v-flex>
                  <span style="text-align: left;font-weight: bold;">*ระบุประเภทนักวิจัย</span>
                </v-flex>
              </v-layout>
              <v-layout style="padding-left: 6rem">
                <v-flex>
                  <v-radio-group v-model="form.researcherTypeID">
                    <v-radio color="#3E7662" v-for="researcherType in researcherTypeList" v-bind:key="researcherType.id"
                      :value="researcherType.id" :label="researcherType.typeName"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <!--<v-layout style="padding-left: 160px" mt-n6>-->
              <!--<v-flex>-->
              <!--<v-radio-group row v-model="form.education" :disabled="form.position !== '3' " @change="clearRadio('adjustEducation')">-->
              <!--<v-radio color="#3E7662" value="1" label="ป.ตรี"></v-radio>-->
              <!--<v-radio color="#3E7662" value="2" label="ป.โท"></v-radio>-->
              <!--<v-radio color="#3E7662" value="3" label="ป.เอก"></v-radio>-->
              <!--<v-radio color="#3E7662" value="4" label="อื่นๆ ระบุ"></v-radio>-->
              <!--<v-flex xs3>-->
              <!--<textfield-form-append-->
              <!--:disabled="form.education !== '4' "-->
              <!--:model="form.otherAnswer"-->
              <!--@update-data="updateData('otherAnswer', $event)"-->
              <!--&gt;</textfield-form-append>-->
              <!--</v-flex>-->

              <!--</v-radio-group>-->
              <!--</v-flex>-->
              <!--</v-layout>-->

              <v-layout style="text-align: left">
                <v-flex>
                  <span style="text-align: left;font-weight: bold;">*ระบุประเภทงานวิจัย</span>
                </v-flex>
              </v-layout>
              <v-layout style="padding-left: 6rem" mt-6>
                <v-flex>
                  <v-radio-group v-model="form.researchTypeID">
                    <v-radio color="#3E7662" value="1"
                      label="งานวิจัยที่เป็นการทดลอง, Lab, การทดลองในเนื้อเยื่อ/สิ่งส่งตรวจ"></v-radio>
                    <v-radio color="#3E7662" value="2"
                      label="งานวิจัยที่ใช้แบบสอบถาม แบบสัมภาษณ์ ในการเก็บข้อมูล"></v-radio>
                    <v-radio color="#3E7662" value="3"
                      label="งานวิจัยที่เก็บข้อมูลในคน ผู้ป่วย เจ้าหน้าที่ ฯลฯ"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout style="text-align: left">
                <v-flex>
                  <span style="text-align: left;font-weight: bold;">*ประเภทโครงร่างการวิจัย</span>
                </v-flex>
              </v-layout>
              <v-layout style="padding-left: 6rem" mt-6>
                <v-flex shrink mr-4 pt-2 style="text-align: right;font-weight: bold;">
                  <span>ประเภทโครงร่างการวิจัย</span>
                </v-flex>
                <v-flex xs3 pr-4>
                  <textfield-form :model="ymidtype" readonly></textfield-form>
                </v-flex>
                <v-flex shrink mr-4 pt-2 style="text-align: right;font-weight: bold;">
                  <span>รหัสโครงร่างการวิจัย</span>
                </v-flex>
                <v-flex xs3 pr-4>
                  <textfield-form :model="ymidname" readonly></textfield-form>
                </v-flex>
              </v-layout>

              <!-- row 2 -->
              <v-layout mt-12>
                <v-flex xs6 mr-4 pt-2 style="text-align: left;font-weight: bold;">
                  <span>ชื่อผู้วิจัย</span>
                </v-flex>
                <v-flex xs3 pr-4 pt-2 style="text-align: left;font-weight: bold;">
                  <span>สังกัด</span>
                </v-flex>
                <v-flex xs3 pr-4 pt-2 style="text-align: left;font-weight: bold;">
                  <span>เบอร์โทรศัพท์ติดต่อ</span>
                </v-flex>
              </v-layout>

              <v-layout pt-2>
                <v-flex xs6 pr-4>
                  <textfield-form :model="form.researcherName" @update-data="updateData('researcherName', $event)"
                    readonly></textfield-form>
                </v-flex>
                <v-flex xs3 pr-4>
                  <textfield-form :model="form.affiliation" @update-data="updateData('affiliation', $event)"
                    readonly></textfield-form>
                </v-flex>
                <v-flex xs3 pr-4>
                  <textfield-form :model="form.researcherPhoneNumber"
                    @update-data="updateData('researcherPhoneNumber', $event)" readonly></textfield-form>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex xs6 pt-2 style="text-align: left;font-weight: bold;">
                  <span>ผู้ประสานงานวิจัย</span>
                </v-flex>
                <v-flex xs3 pr-4 mr-2 pt-2 style="text-align: left;font-weight: bold;">
                  <span>เบอร์โทรศัพท์ติดต่อ</span>
                </v-flex>
              </v-layout>

              <v-layout pt-2>
                <v-flex xs6 pr-4>
                  <textfield-form :model="form.coordinatorName" @update-data="updateData('coordinatorName', $event)"
                    readonly></textfield-form>
                </v-flex>
                <v-flex xs3 pr-4>
                  <textfield-form :model="form.coordinatorPhoneNumber"
                    @update-data="updateData('coordinatorPhoneNumber', $event)" readonly></textfield-form>
                </v-flex>
              </v-layout>
            </v-card>

            <!-- blog 2 -->
            <v-layout mt-3 style="background-color: #3E7662;">
              <v-flex xs3 pl-6 my-5 ml-8 style="text-align: center;font-size: 28px;color: white;font-weight: bolder">
                <div style="font-size: 18px;">หัวข้อ</div>
              </v-flex>
              <v-flex xs6 pl-6 my-5 ml-8 style="text-align: center;font-size: 28px;color: white;font-weight: bolder">
                <div style="font-size: 18px;">รายละเอียดโครงร่างการวิจัย</div>
              </v-flex>
              <v-flex xs3 pl-6 my-5 ml-8 style="text-align: center;font-size: 28px;color: white;font-weight: bolder">
                <div style="font-size: 18px;">มี/ไม่มี หมายเหตุ</div>
              </v-flex>
            </v-layout>
            <v-layout pb-8 mb-8 style="background-color: white;">
              <v-flex>
                <v-card class="ma-8">
                  <!-- header -->
                  <v-layout py-3 style="background-color: #3E7662;color: white;">
                    <v-flex pr-12 pl-12 style="text-align: left;font-size: 18px;font-weight: bold;">
                      <span>ก) เอกสารที่นักวิจัยต้องส่ง</span>
                    </v-flex>
                  </v-layout>
                  <!-- row detail -->

                  <!--1-->
                  <v-layout px-6 py-3 align-center>
                    <v-flex xs10 class="d-flex justify-start">
                      <row>
                        <v-layout>
                          <span>1. หนังสือรับรองจากผู้บังคับบัญชาระดับ ผอ.กอง หรือ
                            หัวหน้าภาควิชา จำนวน 1 ชุด</span>
                        </v-layout>
                        <v-layout pl-3>
                          <span>หนังสือขอความร่วมมือจากคณะ / สถาบัน จำนวน 1
                            ชุด</span>
                        </v-layout>
                      </row>
                    </v-flex>
                    <v-flex shrink class="mr-4">
                      <v-radio-group v-model="form.hasOne" hide-details column>
                        <v-radio color="#3E7662" label="มี" value="1"></v-radio>
                        <v-radio color="#3E7662" label="ไม่มี" value="0" @click.native="checkRadio('hasOne')"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs2 style="font-weight: bold">
                      <textarea-form placeholder="หมายเหตุ" hide-detail :model="form.noteOne"
                        @update-data="updateData('noteOne', $event)" />
                    </v-flex>
                  </v-layout>

                  <!--3-->
                  <v-layout px-6 pt-3 align-center style="background-color: #FBF6F3;">
                    <v-flex xs10 pt-2 pr-12 style="text-align: left">
                      <v-layout>
                        <v-flex shrink>2. ส่งแบบเสนอโครงการวิจัย </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex shrink class="mr-4">
                      <v-radio-group v-model="form.hasTwo" hide-details column>
                        <v-radio color="#3E7662" label="มี" value="1"></v-radio>
                        <v-radio color="#3E7662" label="ไม่มี" value="0" @click.native="checkRadio('hasTwo')"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs2 style="font-weight: bold">
                      <textarea-form placeholder="หมายเหตุ" hide-detail :model="form.noteTwo"
                        @update-data="updateData('noteTwo', $event)" />
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8 pr-6 pb-6 align-center style="background-color: #FBF6F3;">
                    <v-flex shrink>
                      <div class="row">
                        <v-checkbox v-model="form.firstTwoCheckbox" hide-details color="#3E7662"
                          label="2.1 โครงร่างการวิจัยภาษาไทย  และ/หรือภาษาอังกฤษ ฉบับสมบูรณ์"></v-checkbox>
                        <a v-if="researchFilePath" :href="researchFilePath" style="color:#3e7662" class="pl-4 pt-1"
                          target="_blank">ดูเอกสารโครงร่างการวิจัย</a>
                      </div>
                      <div class="row">
                        <v-checkbox v-model="form.secondTwoCheckbox" hide-details color="#3E7662"
                          label="2.2  โครงร่างการวิจัยฉบับย่อภาษาไทย(ถ้าไม่มีโครงร่างการวิจัยภาษาไทยแต่มีโครงร่างภาษาอังกฤษฉบับสมบูรณ์ )"></v-checkbox>
                      </div>
                    </v-flex>
                  </v-layout>

                  <!--7-->
                  <v-layout px-6 py-3 pb-6 align-center>
                    <v-flex xs10 pt-2 pr-12 style="text-align: left">
                      <v-layout>
                        <v-flex shrink>3. เอกสารผู้วิจัย และผู้วิจัยร่วม /ที่ปรึกษา</v-flex>
                      </v-layout>
                      <v-layout pt-4>
                        <v-checkbox v-model="form.hasFirstThree" hide-details color="#3E7662"
                          label="3.1 ประวัติผู้วิจัย และผู้วิจัยร่วม /ที่ปรึกษา (Curriculum vitae)"></v-checkbox>
                      </v-layout>
                      <v-layout mt-2>
                        <v-checkbox v-model="form.hasSecondThree" hide-details color="#3E7662"
                          label="3.2 หนังสือข้อตกลงรักษาความลับของข้อมูลฯ (RO_1_2563)"></v-checkbox>
                      </v-layout>
                      <v-layout mt-2>
                        <v-checkbox v-model="form.hasThirdThree" hide-details color="#3E7662"
                          label="3.3 หนังสือข้อตกลงในการดำเนินการวิจัย (RO_2_2563) "></v-checkbox>
                      </v-layout>
                    </v-flex>

                    <v-flex shrink class="mr-4">
                      <v-radio-group v-model="form.hasThree" hide-details column>
                        <v-radio color="#3E7662" label="มี" value="1"></v-radio>
                        <v-radio color="#3E7662" label="ไม่มี" value="0" @click.native="checkRadio('hasThree')"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs2 style="font-weight: bold">
                      <textarea-form placeholder="หมายเหตุ" hide-detail :model="form.noteThree"
                        @update-data="updateData('noteThree', $event)" />
                    </v-flex>
                  </v-layout>

                  <!--15-->
                  <v-layout px-6 pt-3 pb-6 align-center style="background-color: #FBF6F3;">
                    <v-flex xs10 pt-2 pr-12 style="text-align: left">
                      <v-layout>
                        <v-flex shrink>4. เอกสารรับรองโครงร่างการวิจัย จาก CREC</v-flex>
                      </v-layout> </v-flex><v-flex shrink class="mr-4">
                      <v-radio-group v-model="form.hasFour" hide-details column>
                        <v-radio color="#3E7662" label="มี" value="1"></v-radio>
                        <v-radio color="#3E7662" label="ไม่มี" value="0" @click.native="checkRadio('hasFour')"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs2 style="font-weight: bold">
                      <textarea-form placeholder="หมายเหตุ" hide-detail :model="form.noteFour"
                        @update-data="updateData('noteFour', $event)" />
                    </v-flex>
                  </v-layout>

                  <v-layout py-3 style="background-color: #3E7662;color: white;">
                    <v-flex pr-12 pl-12 style="text-align: left;font-size: 18px;font-weight: bold;">
                      ข) เอกสารอื่นๆ
                    </v-flex>
                  </v-layout>
                  <!--2-->
                  <v-layout px-6 pt-3 pb-6 align-center>
                    <v-flex xs10 pt-2 pr-12 style="text-align: left">
                      <v-layout>
                        <v-flex>
                          <span>5. แบบรายงานการส่งโครงร่างการวิจัย (RF01_2563)
                            ที่ผู้วิจัย และผู้ร่วมวิจัย (หรือที่ปรึกษา)
                            ลงนาม</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex shrink class="mr-4">
                      <v-radio-group v-model="form.hasFive" hide-details column>
                        <v-radio color="#3E7662" label="มี" value="1"></v-radio>
                        <v-radio color="#3E7662" label="ไม่มี" value="0" @click.native="checkRadio('hasFive')"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs2 style="font-weight: bold">
                      <textarea-form placeholder="หมายเหตุ" hide-detail :model="form.noteFive"
                        @update-data="updateData('noteFive', $event)" />
                    </v-flex>
                  </v-layout>
                  <!--4-->
                  <v-layout px-6 pt-3 pb-6 align-center style="background-color: #FBF6F3;">
                    <v-flex xs10 pt-2 pr-12 style="text-align: left">
                      <v-layout>
                        <v-flex shrink>6. แบบบันทึกข้อมูล (ถ้ามี)</v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex shrink class="mr-4">
                      <v-radio-group v-model="form.hasSix" hide-details column>
                        <v-radio color="#3E7662" label="มี" value="1"></v-radio>
                        <v-radio color="#3E7662" label="ไม่มี" value="0" @click.native="checkRadio('hasSix')"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs2 style="font-weight: bold">
                      <textarea-form placeholder="หมายเหตุ" hide-detail :model="form.noteSix"
                        @update-data="updateData('noteSix', $event)" />
                    </v-flex>
                  </v-layout>

                  <!--5-->
                  <v-layout px-6 py-3 mb-4 align-center>
                    <v-flex xs10 pt-2 pr-12 style="text-align: left">
                      <v-layout>
                        <v-flex shrink>7. แบบสอบถามหรือสัมภาษณ์ (ถ้ามี)</v-flex>
                      </v-layout>
                      <v-layout mt-4 pl-4>
                        <v-flex shrink>สมุดบันทึก (diary) (ถ้ามี) </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex shrink class="mr-4">
                      <v-radio-group v-model="form.hasSeven" hide-details column>
                        <v-radio color="#3E7662" label="มี" value="1"></v-radio>
                        <v-radio color="#3E7662" label="ไม่มี" value="0" @click.native="checkRadio('hasSeven')"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs2 style="font-weight: bold">
                      <textarea-form placeholder="หมายเหตุ" hide-detail :model="form.noteSeven"
                        @update-data="updateData('noteSeven', $event)" />
                    </v-flex>
                  </v-layout>

                  <!--6-->
                  <v-layout px-6 py-3 align-center style="background-color: #FBF6F3;">
                    <v-flex xs10 pt-2 pr-12 style="text-align: left">
                      <div>
                        8. เอกสารชี้แจงข้อมูลผู้ร่วมโครงการวิจัย
                        /หนังสือแสดงเจตนา ภาษาไทย (Information sheet/consent)
                        (ถ้าต้องใช้)
                      </div>
                    </v-flex>

                    <v-flex shrink class="mr-4">
                      <v-radio-group v-model="form.hasEight" hide-details column>
                        <v-radio color="#3E7662" label="มี" value="1"></v-radio>
                        <v-radio color="#3E7662" label="ไม่มี" value="0" @click.native="checkRadio('hasEight')"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs2 style="font-weight: bold">
                      <textarea-form placeholder="หมายเหตุ" hide-detail :model="form.noteEight"
                        @update-data="updateData('noteEight', $event)" />
                    </v-flex>
                  </v-layout>
                  <div class="pb-4 pl-10 text-start" style="background-color: #FBF6F3;">
                    (เด็กอายุ 7-12 ปี ควรมีเอกสารชี้แจงข้อมูลแก่เด็ก หรือ
                    Assent)
                  </div>

                  <!--8-->
                  <v-layout px-6 py-3 pb-6 align-center>
                    <v-flex xs10 pt-2 pr-12 style="text-align: left">
                      <v-layout>
                        <v-flex shrink>9. เอกสารอื่นๆ ได้แก่ โฆษณา สิ่งตีพิมพ์ บทความ สื่อ
                          เช่น วิดีโอ ซีดี เทป</v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex shrink class="mr-4">
                      <v-radio-group v-model="form.hasNine" hide-details column>
                        <v-radio color="#3E7662" label="มี" value="1"></v-radio>
                        <v-radio color="#3E7662" label="ไม่มี" value="0" @click.native="checkRadio('hasNine')"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs2 style="font-weight: bold">
                      <textarea-form placeholder="หมายเหตุ" hide-detail :model="form.noteNine"
                        @update-data="updateData('noteNine', $event)" />
                    </v-flex>
                  </v-layout>

                  <!--9-->
                  <v-layout px-6 py-3 align-center style="background-color: #FBF6F3;">
                    <v-flex xs10 pt-2 pr-12 style="text-align: left">
                      <div>
                        10. ซีดีที่มีอิเล็กทรอนิกส์ไฟล์ของโครงร่างการวิจัย จำนวน
                        1 แผ่น (word & pdf file)
                      </div>
                      <div>(ถ้าไม่ได้ส่งผ่านอีเมล์ หรือwebsite)</div>
                    </v-flex>

                    <v-flex shrink class="mr-4">
                      <v-radio-group v-model="form.hasTen" hide-details column>
                        <v-radio color="#3E7662" label="มี" value="1"></v-radio>
                        <v-radio color="#3E7662" label="ไม่มี" value="0" @click.native="checkRadio('hasTen')"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs2 style="font-weight: bold">
                      <textarea-form placeholder="หมายเหตุ" hide-detail :model="form.noteTen"
                        @update-data="updateData('noteTen', $event)" />
                    </v-flex>
                  </v-layout>

                  <!--&lt;!&ndash;10&ndash;&gt;-->
                  <!--<v-layout px-6 py-3 pb-4 align-center>-->
                  <!--<v-flex xs10 pt-2 pr-12 style="text-align: left" >10. หนังสือขอความร่วมมือจากคณะ /สถาบัน (แทนข้อ 1) จำนวน 1 ชุด</v-flex>-->
                  <!--<v-flex shrink class="mr-4">-->
                  <!--<v-radio-group v-model="form.hasTen" hide-details column >-->
                  <!--<v-radio color="#3E7662" label="มี" value="1"></v-radio>-->
                  <!--<v-radio color="#3E7662" label="ไม่มี" value="0" @click.native="checkRadio('hasTen')"></v-radio>-->
                  <!--</v-radio-group>-->
                  <!--</v-flex>-->
                  <!--<v-flex xs2 style="font-weight: bold">-->
                  <!--<textfield-form-->
                  <!--:disabled="form.hasTen === '0'"-->
                  <!--:background-color="form.hasTen !== '0' ? '#FBF6F3' : '#D8D8D8'"-->
                  <!--placeholder="หมายเหตุ" hide-detail-->
                  <!--:model="form.noteTen"-->
                  <!--@update-data="updateData('noteTen', $event)"-->
                  <!--/>-->
                  <!--</v-flex>-->
                  <!--</v-layout>-->
                  <!--11-->
                  <v-layout px-6 py-3 pb-4 align-center>
                    <v-flex xs10 pt-2 pr-12 style="text-align: left">
                      <v-layout>
                        <v-flex shrink>11. สำเนาหนังสือรับรองว่า
                          ได้ผ่านการสอบโครงร่างการวิจัยจากคณะ
                          /สถาบันแล้ว</v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex shrink class="mr-4">
                      <v-radio-group v-model="form.hasEleven" hide-details column>
                        <v-radio color="#3E7662" label="มี" value="1"></v-radio>
                        <v-radio color="#3E7662" label="ไม่มี" value="0"
                          @click.native="checkRadio('hasEleven')"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs2 style="font-weight: bold">
                      <textarea-form placeholder="หมายเหตุ" hide-detail :model="form.noteEleven"
                        @update-data="updateData('noteEleven', $event)" />
                    </v-flex>
                  </v-layout>

                  <!--12-->
                  <v-layout px-6 py-3 pb-4 align-center style="background-color: #FBF6F3;">
                    <v-flex xs10 pt-2 pr-12 style="text-align: left">
                      <v-layout>
                        <v-flex shrink>12. คู่มือผู้วิจัย (Investigator brochure)
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex shrink class="mr-4">
                      <v-radio-group v-model="form.hasTwelve" hide-details column>
                        <v-radio color="#3E7662" label="มี" value="1"></v-radio>
                        <v-radio color="#3E7662" label="ไม่มี" value="0"
                          @click.native="checkRadio('hasTwelve')"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs2 style="font-weight: bold">
                      <textarea-form placeholder="หมายเหตุ" hide-detail :model="form.noteTwelve"
                        @update-data="updateData('noteTwelve', $event)" />
                    </v-flex>
                  </v-layout>

                </v-card>

                <v-layout px-12 pt-12 pb-2 style="text-align: left">
                  <v-flex>
                    <span style="font-weight: bolder;font-size: 18px;padding-top: 32px">Note:</span>
                  </v-flex>
                  <v-flex class="justify-end text-right">
                    <v-btn dark color="#3E7662" @click="noteGenerate()">Generate ข้อความจากแบบฟอร์ม</v-btn>
                  </v-flex>
                </v-layout>
                <v-layout px-12>
                  <v-flex>
                    <v-textarea filled outlined v-model="form.note" background-color="#FBF6F3" color="#3E7662" />
                  </v-flex>
                </v-layout>
                <!--sign-->
                <v-layout py-12 style="background-color: white;padding-left: 60px;padding-right: 70px;">
                  <v-flex>
                    <v-layout style="font-size: 18px; font-weight: bolder;text-align: left">
                      <v-flex>
                        <span>การตรวจสอบ</span>
                      </v-flex>
                    </v-layout>
                    <v-layout pt-10 justify-space-between style="font-size: 16px">
                      <!--<v-flex xs4 pl-3 mr-6 class="text-field-center">-->
                      <!--<textfield-form-append-->
                      <!--:model="form.verifierName"-->
                      <!--css="font-weight: bold;"-->
                      <!--label="ลงชื่อ"-->
                      <!--hide-detail-->
                      <!--@update-data="updateData('verifierName', $event)"-->
                      <!--&gt;</textfield-form-append>-->
                      <!--</v-flex>-->
                      <!--<v-flex pt-2 pr-4 class="text-start">-->
                      <!--<span  style="font-weight: bold">(เจ้าหน้าที่ตรวจสอบ)</span>-->
                      <!--</v-flex>-->
                      <v-flex xs5>
                        <DateInputForm :model="verifyDate" label="วันที่ตรวจสอบ" readonly
                          @update-data="updateDate('verifyDate', $event)"></DateInputForm>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <v-layout mt-8 mx-12>
                  <v-flex style="font-weight: bold" d-flex justify-start>
                    <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                  </v-flex>
                  <v-flex style="font-weight: bold" d-flex justify-end>
                    <span>หน้า 1 จาก 1 หน้า</span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <!-- Button Save -->
            <v-layout mb-12 justify-space-between>
              <v-flex style="text-align: left">
                <v-btn style="color: #3E7662;font-weight: bold" class="mx-4" depressed color="#ffffff"
                  @click="$router.push('/new-research')">ย้อนกลับ</v-btn>
              </v-flex>
              <v-flex style="text-align: right">
                <v-btn depressed @click="save('save')" color="white"
                  style="margin-right: 12px;color:#3E7662;font-weight: bold">
                  <v-icon class="mr-3">add</v-icon>
                  <span>บันทึกเพื่อแก้ไข</span>
                </v-btn>
                <v-btn depressed dark color="#3E7662" @click="save('saveStatus')">
                  <v-icon class="mr-3">add</v-icon>
                  <span>บันทึกเพื่อพิจารณา</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-pageAndLine="fullpageAndLine">
      </loading>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../components/input/TextfieldForm";
import DateInputForm from "../../components/input/DateInputForm";
import TextareaForm from "../../components/input/TextareaForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
import DateInputFormAppend from "../../components/input/DateInputFormAppend";
import { mapState } from "vuex";
import CheckboxForm from "../../components/input/CheckboxForm";

export default {
  name: "ResearchVerify",
  components: {
    CheckboxForm,
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
    TextfieldFormAppend,
    DateInputFormAppend,
    // editAdd,
  },
  data: () => ({
    isLoading: false,
    fullpageAndLine: true,
    selected: [],
    dialog: false,
    researcherTypeList: [],
    form: {
      researchName: "",
      otherAnswer: "",
      researcherName: "",
      affiliation: "",
      researcherPhoneNumber: "",
      coordinatorName: "",
      coordinatorPhoneNumber: "",
      hasOne: "0",
      noteOne: "",
      hasTwo: "0",
      noteTwo: "",
      firstTwoCheckbox: false,
      secondTwoCheckbox: false,
      hasThree: "0",
      noteThree: "",
      hasFirstThree: false,
      hasSecondThree: false,
      hasThirdThree: false,
      hasFour: "0",
      noteFour: "",
      hasFive: "0",
      noteFive: "",
      hasSix: "0",
      noteSix: "",
      hasSeven: "0",
      noteSeven: "",
      hasEight: "0",
      noteEight: "",
      hasNine: "0",
      noteNine: "",
      hasTen: "0",
      noteTen: "",
      hasEleven: "0",
      noteEleven: "",
      hasTwelve: "0",
      noteTwelve: "",
      note: "",
      verifierName: "",
      verifyDate: "",
      researchTypeID: "",
      researcherTypeID: "",
    },
    researchAllHeaders: [
      {
        text: "ผู้รับผิดชอบอ่านโครงร่างการวิจัย",
        value: "responsive",
        align: "center",
      },
      {
        text: "วันที่ส่งอ่าน /ลงนามจนท.ส่ง",
        value: "sendDateShow",
        align: "center",
      },
      { text: "วันที่กำหนดรับ", value: "receiveSetDateShow", align: "center" },
      {
        text: "วันที่รับโครงร่างคืน",
        value: "receiveDateShow",
        align: "center",
      },
      { text: "หมายเหตุ", value: "note", align: "center" },
      { text: "ลบ", value: "delete", align: "center" },
    ],
    itemResearchAll: [],
    itemResearchAllShow: [],
    itemTableEdit: [],
    sendAndReceiveResearch: {
      responsive: "",
      sendDate: "",
      receiveSetDate: "",
      receiveDate: "",
      note: "",
    },
    formTable: {},
    verifyDate: "",
    sendDate: "",
    receiveSetDate: "",
    receiveDate: "",
    researchFileName: "",
    researchFilePath: "",
    ymidtype: "",
    ymidname: ""
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    if (this.$route.params.researchName == null) {
      this.$router.push("/new-research");
    }
    this.getCurrentDate();
    this.form.researchName = this.$route.params.researchName;
    this.form.researcherName = this.$route.params.researcherName;
    this.form.researcherPhoneNumber = this.$route.params.researcherMobile;
    this.form.coordinatorName = this.$route.params.coordinatorName;
    this.form.coordinatorPhoneNumber = this.$route.params.coordinatorMobile;
    this.form.affiliation = this.$route.params.researcherAffiliation;
    this.getResearchVerify(this.$route.params.id);
    this.getResearcherTypeList();
    this.getResearch();
  },
  methods: {
    getCurrentDate() {
      let today = new Date();
      let month = "" + (today.getMonth() + 1);
      let day = "" + today.getDate();
      let year = today.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      console.log([year, month, day].join("-"));
      this.form.verifyDate = [year, month, day].join("-");
      this.verifyDate = this.changeDate([year, month, day].join("-"));
    },
    updateData(name, val) {
      this.form[name] = val;
    },
    getResearch() {
      this.$store
        .dispatch("Research/getFormResearch1", this.$route.params.id)
        .then((res) => {
          this.researchFileName = res.researchFile;
          this.researchFilePath = res.researchFilePath;
          this.ymidname = res.ymidname;
          this.ymidtype = res.ymidtype;
        });
    },
    checkRadio(name) {
      switch (name) {
        case "hasOne":
          this.form.noteOne = "";
          break;
        case "hasTwo":
          this.form.noteTwo = "";
          break;
        case "hasThree":
          this.form.noteTwo = "";
          break;
        case "hasFour":
          this.form.noteFour = "";
          break;
        case "hasFive":
          this.form.noteFive = "";
          break;
        case "hasSix":
          this.form.noteSix = "";
          break;
        case "hasSeven":
          this.form.noteSix = "";
          break;
        case "hasEight":
          this.form.noteEight = "";
          break;
        case "hasNine":
          this.form.noteNine = "";
          break;
        case "hasTen":
          this.form.noteTen = "";
          break;
        case "hasEleven":
          this.form.noteEleven = "";
          break;
        case "hasTwelve":
          this.form.noteTwelve = "";
          break;
      }
    },
    updateDate(name, val) {
      if (name === "verifyDate") {
        this.form.verifyDate = val.date;
        this.verifyDate = this.changeDate(val.date);
      }
      if (name === "receiveSetDate") {
        this.sendAndReceiveResearch.receiveSetDate = val.date;
        this.receiveSetDate = this.changeDate(val.date);
      }
      if (name === "receiveDate") {
        this.sendAndReceiveResearch.receiveDate = val.date;
        this.receiveDate = this.changeDate(val.date);
      }
      if (name === "sendDate") {
        this.sendAndReceiveResearch.sendDate = val.date;
        this.sendDate = this.changeDate(val.date);
      }
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);

      sub_year = parseInt(sub_year) + 543;

      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    tableUpdateData(name, val) {
      this.sendAndReceiveResearch[name] = val;
    },
    getResearchVerify(id) {
      this.isLoading = true;
      this.$store
        .dispatch("Research/getResearchVerify", id)
        .then((res) => {
          console.log("res",res);
          if (res !== "don't have research verify yet") {
            console.log("1");
            if (res.type === "edit") {
              console.log('datares', res);
              this.form.researchName = res.researchName;
              this.form.researcherTypeID = res.researcherTypeID;
              this.form.researchTypeID = res.researchTypeID ? res.researchTypeID.toString() : "";
              this.form.otherAnswer = res.otherAnswer;
              this.form.researcherName = res.researcherName;
              this.form.affiliation = res.affiliation;
              this.form.researcherPhoneNumber = res.researcherPhoneNumber;
              this.form.coordinatorName = res.coordinatorName;
              this.form.coordinatorPhoneNumber = res.coordinatorPhoneNumber;
              this.form.hasOne = res.hasOne ? res.hasOne.toString() : "";
              this.form.noteOne = res.noteOne ? res.noteOne.toString() : "";
              this.form.hasTwo = res.hasTwo ? res.hasTwo.toString() : "";
              this.form.noteTwo = res.noteTwo ? res.noteTwo : "";
              this.form.firstTwoCheckbox = res.firstTwoCheckbox;
              this.form.secondTwoCheckbox = res.secondTwoCheckbox;
              this.form.hasThree = res.hasThree ? res.hasThree.toString() : "";
              this.form.noteThree = res.noteThree ? res.noteThree : "";
              this.form.hasFirstThree = res.hasFirstThree;
              this.form.hasSecondThree = res.hasSecondThree;
              this.form.hasThirdThree = res.hasThirdThree;
              this.form.hasFour = res.hasFour ? res.hasFour.toString() : "";
              this.form.noteFour = res.noteFour ? res.noteFour : "";
              this.form.hasFive = res.hasFive ? res.hasFive.toString() : "";
              this.form.noteFive = res.noteFive ? res.noteFive : "";
              this.form.hasSix = res.hasSix ? res.hasSix.toString() : "";
              this.form.noteSix = res.noteSix ? res.noteSix : "";
              this.form.hasSeven = res.hasSeven ? res.hasSeven.toString() : "";
              this.form.noteSeven = res.noteSeven ? res.noteSeven : "";
              this.form.hasEight = res.hasEight ? res.hasEight.toString() : "";
              this.form.noteEight = res.noteEight ? res.noteEight : "";
              this.form.hasNine = res.hasNine ? res.hasNine.toString() : "";
              this.form.noteNine = res.noteNine ? res.noteNine : "";
              this.form.hasTen = res.ten ? res.hasTen.toString() : "";
              this.form.noteTen = res.noteTen ? res.noteTen : "";
              this.form.hasEleven = res.hasEleven ? res.hasEleven.toString() : "";
              this.form.noteEleven = res.noteEleven ? res.noteEleven : "";
              this.form.hasTwelve = res.hasTwelve ? res.hasTwelve.toString() : "";
              this.form.noteTwelve = res.noteTwelve ? res.noteTwelve : "";
              this.form.note = res.note ? res.note : "";
              this.form.verifierName = res.verifierName;
              this.form.verifyDate = res.verifyDate;
              this.verifyDate = this.changeDate(res.verifyDate);
            } else {
              this.form.researcherTypeID = res.researcherTypeID;
              this.form.researchTypeID = res.researchTypeID ? res.researchTypeID.toString() : "";
            }
            this.isLoading = false;
          }
          this.isLoading = false;
        })
        .catch((e) => {
          console.log(e);
          console.log("ERROR2");
          this.isLoading = false;
        });
    },
    save(saveMethod) {
      this.form["saveMethod"] = saveMethod;
      if (saveMethod === "saveStatus") {
        Swal.fire({
          title: "คุณต้องการบันทึกหรือไม่?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3E7662",
          cancelButtonColor: "rgb(189, 189, 189)",
          cancelButtonText: "ยกเลิก",
          confirmButtonText: "บันทึก",
        }).then((result) => {
          console.log("save is loading", this.isLoading);
          if (result.value) {
            this.isLoading = true;
            this.form["researchID"] = this.$route.params.id;
            this.$store
              .dispatch("Research/saveResearchVerify", this.form)
              .then((res) => {
                this.isLoading = false;
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "บันทึกสำเร็จ",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(() => {
                  this.$router.push("/new-research");
                });
              })
              .catch((e) => {
                this.isLoading = false;
                if (e.response.data.errors) {
                  for (var k in e.response.data.errors) {
                    Swal.fire({
                      title: "เกิดข้อผิดพลาด",
                      text: e.response.data.errors[k][0],
                      icon: "warning",
                      confirmButtonColor: "#3E7662",
                    }).then(() => {
                      this.$vuetify.goTo(`#${k}`);
                    });
                  }
                } else {
                  Swal.fire({
                    title: "Save failed!",
                    text: "บันทึกไม่สำเร็จ",
                    icon: "warning",
                  })
                }
              });
          }
        });
      } else {
        this.isLoading = true;
        this.form["researchID"] = this.$route.params.id;
        console.log(this.form);
        this.$store
          .dispatch("Research/saveResearchVerify", this.form)
          .then((res) => {
            this.isLoading = false;
            Swal.fire({
              position: "center",
              icon: "success",
              title: "บันทึกสำเร็จ",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              this.$router.push("/new-research");
            });
          })
          .catch((e) => {
            this.isLoading = false;
            if (e.response.data.errors) {
              for (var k in e.response.data.errors) {
                Swal.fire({
                  title: "เกิดข้อผิดพลาด",
                  text: e.response.data.errors[k][0],
                  icon: "warning",
                  confirmButtonColor: "#3E7662",
                }).then(() => {
                  this.$vuetify.goTo(`#${k}`);
                });
              }
            } else {
              Swal.fire({
                title: "Save failed!",
                text: "บันทึกไม่สำเร็จ",
                icon: "warning",
              })
            }
          });
      }
    },
    deleteResearchVerify() {
      this.isLoading = true;
      Swal.fire({
        title: "คุณต้องการลบข้อมูลหรือไม่ ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        cancelButtonText: "ไม่ต่องการ",
        confirmButtonText: "ใช่ ลบ",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("Research/deleteResearchVerify", this.$route.query.id)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "ลบข้อมูลสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              });
              this.isLoading = false;
              this.$router.push("/new-research");
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              } else {
                Swal.fire({
                  title: "Save failed!",
                  text: "ลบไม่สำเร็จ",
                  icon: "warning",
                })
              }
            });
        }
      });
    },
    otherChangeCheckbox() {
      if (!this.form.hasOtherChange) {
        this.form.otherChange = "";
      }
    },
    changeTitleCheckbox() {
      if (!this.form.hasChangeInTitle) {
        this.form.changeInTitle = "";
      }
    },
    add() {
      if (
        this.sendAndReceiveResearch.responsive &&
        this.sendAndReceiveResearch.sendDate &&
        this.sendAndReceiveResearch.receiveSetDate &&
        this.sendAndReceiveResearch.receiveDate &&
        this.sendAndReceiveResearch.note
      ) {
        this.itemResearchAll.push({
          index: new Date().valueOf(),
          responsive: this.sendAndReceiveResearch.responsive,
          sendDate: this.sendAndReceiveResearch.sendDate,
          receiveSetDate: this.sendAndReceiveResearch.receiveSetDate,
          receiveDate: this.sendAndReceiveResearch.receiveDate,
          note: this.sendAndReceiveResearch.note,
          sendDateShow: this.changeDate(this.sendAndReceiveResearch.sendDate),
          receiveSetDateShow: this.changeDate(
            this.sendAndReceiveResearch.receiveSetDate
          ),
          receiveDateShow: this.changeDate(
            this.sendAndReceiveResearch.receiveDate
          ),
        });
        this.sendDate = "";
        this.receiveSetDate = "";
        this.receiveDate = "";
        this.sendAndReceiveResearch.responsive = "";
        this.sendAndReceiveResearch.note = "";
      } else {
        Swal.fire({
          title: "กรุณากรอกข้อมูลให้ครบ",
          icon: "warning",
          confirmButtonColor: "#3E7662",
        });
      }
    },
    deleteRow(val) {
      this.itemResearchAll = this.itemResearchAll.filter(
        (item) => item.index !== val.index
      );
    },
    deleteRowTableEdit(val) {
      this.itemTableEdit = this.itemTableEdit.filter(
        (item) => item.index !== val.index
      );
    },
    noteGenerate() {
      console.log("hasOne", this.form.hasOne);
      let newLine = "\r\n";
      if (this.form.noteOne) {
        this.form.note +=
          "หนังสือรับรองจากผู้บังคับบัญชาระดับ ผอ.กอง หรือ หัวหน้าภาควิชา และ หนังสือขอความร่วมมือจากคณะ / สถาบัน" +
          newLine +
          "-" +
          this.form.noteOne +
          newLine;
      }
      if (this.form.noteTwo) {
        this.form.note +=
          "ส่งแบบเสนอโครงการวิจัย" +
          newLine +
          "-" +
          this.form.noteTwo +
          newLine;
      }
      if (this.form.noteThree) {
        this.form.note +=
          "เอกสารผู้วิจัย และผู้วิจัยร่วม /ที่ปรึกษา" +
          newLine +
          "-" +
          this.form.noteThree +
          newLine;
      }
      if (this.form.noteFour) {
        this.form.note +=
          "เอกสารรับรองโครงร่างการวิจัย จาก CREC" +
          newLine +
          "-" +
          this.form.noteFour +
          newLine;
      }
      if (this.form.noteFive) {
        this.form.note +=
          "แบบรายงานการส่งโครงร่างการวิจัย (RF01_2560) ที่ผู้วิจัย และผู้ร่วมวิจัย (หรือที่ปรึกษา) ลงนาม" +
          newLine +
          "-" +
          this.form.noteFive +
          newLine;
      }
      if (this.form.noteSix) {
        this.form.note +=
          "แบบบันทึกข้อมูล" + newLine + "-" + this.form.noteSix + newLine;
      }
      if (this.form.noteSeven) {
        this.form.note +=
          "แบบสอบถามหรือสัมภาษณ์ และ สมุดบันทึก (diary)" +
          newLine +
          "-" +
          this.form.noteSeven +
          newLine;
      }
      if (this.form.noteEight) {
        this.form.note +=
          "เอกสารชี้แจงข้อมูลผู้ร่วมโครงการวิจัย /หนังสือแสดงเจตนา ภาษาไทย (Information sheet/consent)" +
          newLine +
          "-" +
          this.form.noteEight +
          newLine;
      }
      if (this.form.noteNine) {
        this.form.note +=
          "เอกสารอื่นๆ ได้แก่ โฆษณา สิ่งตีพิมพ์ บทความ สื่อ เช่น วิดีโอ ซีดี เทป" +
          newLine +
          "-" +
          this.form.noteNine +
          newLine;
      }
      if (this.form.noteTen) {
        this.form.note +=
          "ซีดีที่มีอิเล็กทรอนิกส์ไฟล์ของโครงร่างการวิจัย จำนวน 1 แผ่น (word & pdf file) (ถ้าไม่ได้ส่งผ่านอีเมล์ หรือ website)" +
          newLine +
          "-" +
          this.form.noteTen +
          newLine;
      }
      if (this.form.noteEleven) {
        this.form.note +=
          "สำเนาหนังสือรับรองว่า ได้ผ่านการสอบโครงร่างการวิจัยจากคณะ /สถาบันแล้ว" +
          newLine +
          "-" +
          this.form.noteEleven +
          newLine;
      }
      if (this.form.noteTwelve) {
        this.form.note +=
          "คู่มือผู้วิจัย (Investigator brochure)" +
          newLine +
          "-" +
          this.form.noteTwelve +
          newLine;
      }
    },
    getResearcherTypeList() {
      this.isLoading = true;
      this.$store
        .dispatch("Common/getResearcherTypeList")
        .then((res) => {
          this.researcherTypeList = res["all_researcher_type"];
          this.isLoading = false;
        })
        .catch((e) => {
          console.log("ERROR");
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
/*label.v-label.theme--light {*/
/*    color: #544A44;*/
/*}*/
/*.color-label-checkbox {*/
/*    label.v-label.theme--light {*/
/*        color: #3E7662;*/
/*    }*/
/*}*/
</style>
